import { Box, styled } from '@mui/material';

const BackdropWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export default BackdropWrapper;
